import type { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary";
  loading?: boolean;
}

export function Button({ variant = "primary", loading = false, children, disabled, className, ...rest }: ButtonProps) {
  const variantClass = variant === "primary" ? "btn--primary" : "btn--secondary";
  return (
    <button
      className={["btn", variantClass, className].filter(Boolean).join(" ")}
      disabled={disabled || loading}
      aria-busy={loading}
      {...rest}
    >
      {loading ? "Enviando…" : children}
    </button>
  );
}
